/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.controllers {
    export interface IAddFormSectionScope extends angular.IScope {
        close: any;
        dismissModal: any;
        forms: Wars.Domain.Model.Form[];
        formSection: warsApp.models.FormSection;
        listVariables:Wars.Domain.Model.SchemaProperty[];
    }

    export class AddFormSectionController extends BaseModalController {
        scope: IAddFormSectionScope;

        constructor(
            scope: IAddFormSectionScope,
            formSection: warsApp.models.FormSection,
            close: any,
            form:Wars.Domain.Model.Form,
            formService: services.FormService,
            systemLevelService:services.SystemLevelService) {
            super(scope, close);

            var self = this;
            formService.getProcessConfigurationForms(form.processConfiguration_id).then(forms => {
                self.scope.forms = Enumerable.from(forms).where(f => f.id !== form.id).toArray();
            });

            systemLevelService.getSystemLevelVariables()
                .then(s => {
                    self.scope.listVariables=s.variableSchema.properties.filter(v => {
                        return v.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.List;
                    });
                });

            this.scope = scope;
            this.scope.formSection = formSection;
        }
    }
}

warsApp.registerController('AddFormSectionController', ['$scope', 'formSection', 'close', 'form', 'formService', 'systemLevelService']);